import * as React from "react";
const SvgFiRrMoneyTransferAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-money-transfer-alt_svg__a)">
      <path
        fill="#062147"
        d="M14 10c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.346 3 3 3m0-4c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1m-4 13a1 1 0 0 1-1 1H4c-2.206 0-4-1.794-4-4V8.5a1 1 0 0 1 2 0V16c0 1.103.897 2 2 2h5a1 1 0 0 1 1 1m5 0a1 1 0 0 1-1 1h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 1 1m-7-5h12c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4H8C5.794 0 4 1.794 4 4v6c0 2.206 1.794 4 4 4M6 4c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v6c0 1.103-.897 2-2 2H8c-1.103 0-2-.897-2-2zm17.451 16.326-2.223 2.36a.997.997 0 0 1-1.414.042 1 1 0 0 1-.042-1.414L21.01 20H18a1 1 0 0 1 0-2h3.011l-1.239-1.314a1.001 1.001 0 0 1 1.456-1.372l2.244 2.381c.71.709.71 1.9-.021 2.631M7 9.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 9.5m0-5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 7 4.5m11 5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 18 9.5m0-5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 18 4.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-money-transfer-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMoneyTransferAlt;
